import { render, staticRenderFns } from "./ModalEliminaFixture.vue?vue&type=template&id=0b8a3e51&"
import script from "./ModalEliminaFixture.vue?vue&type=script&lang=js&"
export * from "./ModalEliminaFixture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports